import * as React from "react";

function SvgClock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.97 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M11.99 0a11.5 11.5 0 018.46 3.52A11.56 11.56 0 0123.99 12a11.56 11.56 0 01-3.52 8.48A11.5 11.5 0 0111.99 24a11.52 11.52 0 01-8.47-3.52A11.56 11.56 0 01-.01 12a11.56 11.56 0 013.53-8.48A11.52 11.52 0 0111.99 0zm0 21.39a9 9 0 006.64-2.76A9.12 9.12 0 0021.36 12a9.06 9.06 0 00-2.73-6.65 9 9 0 00-6.64-2.74 9.05 9.05 0 00-6.62 2.74A9 9 0 002.61 12a9.07 9.07 0 002.76 6.63 9 9 0 006.62 2.76zm.93-16.17v6.36l3.91 3.92-1.3 1.3-4.43-4.43V5.22z" />
    </svg>
  );
}

const MemoSvgClock = React.memo(SvgClock);
export default MemoSvgClock;
